import React from 'react';

const DeliverablesTable = ({ deliverables, onChange }) => {
  const addRow = () => {
    onChange([
      ...deliverables,
      { voce: '', quantita: 1, unita_misura: 'cad', prezzo_unitario: 0, subtotale: 0 }
    ]);
  };

  const removeRow = (index) => {
    const newDeliverables = deliverables.filter((_, i) => i !== index);
    onChange(newDeliverables);
  };

  const updateRow = (index, field, value) => {
    const newDeliverables = [...deliverables];
    newDeliverables[index][field] = value;

    if (field === 'quantita' || field === 'prezzo_unitario') {
      const quantita = parseFloat(newDeliverables[index].quantita) || 0;
      const prezzo = parseFloat(newDeliverables[index].prezzo_unitario) || 0;
      newDeliverables[index].subtotale = quantita * prezzo;
    }

    onChange(newDeliverables);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-100 dark:border-gray-800">
            <th className="text-left py-4 font-serif text-[10px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-500 w-1/2">Descrizione</th>
            <th className="text-center py-4 font-serif text-[10px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-500 w-20">Q.tà</th>
            <th className="text-center py-4 font-serif text-[10px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-500 w-20">U.M.</th>
            <th className="text-right py-4 font-serif text-[10px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-500 w-32">Prezzo</th>
            <th className="text-right py-4 font-serif text-[10px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-500 w-32">Totale</th>
            <th className="w-10"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
          {deliverables.map((item, index) => (
            <tr key={index} className="group hover:bg-gray-50/50 dark:hover:bg-gray-800/50 transition-colors">
              <td className="py-4 pr-4">
                <input
                  type="text"
                  value={item.voce}
                  onChange={(e) => updateRow(index, 'voce', e.target.value)}
                  className="w-full bg-transparent border-none focus:outline-none focus:ring-0 font-medium placeholder-gray-200 dark:placeholder-gray-700 text-sm text-black dark:text-white"
                  placeholder="Nuovo deliverable..."
                />
              </td>
              <td className="py-4 px-2">
                <input
                  type="number"
                  value={item.quantita}
                  onChange={(e) => updateRow(index, 'quantita', e.target.value)}
                  className="w-full bg-transparent border-none focus:outline-none focus:ring-0 text-center text-gray-600 dark:text-gray-300 text-sm"
                />
              </td>
              <td className="py-4 px-2">
                <select
                  value={item.unita_misura === 'forfait' ? 'forfait' : 'cad'}
                  onChange={(e) => updateRow(index, 'unita_misura', e.target.value)}
                  className="w-full max-w-[5.5rem] mx-auto block bg-transparent border border-transparent hover:border-gray-200 dark:hover:border-gray-700 rounded-md focus:outline-none focus:ring-1 focus:ring-black dark:focus:ring-white text-center text-gray-400 dark:text-gray-500 text-[10px] uppercase tracking-wider cursor-pointer"
                >
                  <option value="cad">CAD</option>
                  <option value="forfait">Forfait</option>
                </select>
              </td>
              <td className="py-4 px-2">
                <input
                  type="number"
                  value={item.prezzo_unitario}
                  onChange={(e) => updateRow(index, 'prezzo_unitario', e.target.value)}
                  className="w-full bg-transparent border-none focus:outline-none focus:ring-0 text-right text-gray-600 dark:text-gray-300 text-sm"
                  step="0.01"
                />
              </td>
              <td className="py-4 pl-4 text-right font-serif text-black dark:text-white text-sm">
                € {(Number(item.subtotale) || 0).toFixed(2)}
              </td>
              <td className="py-4 text-center opacity-0 group-hover:opacity-100 transition-opacity">
                <button
                  onClick={() => removeRow(index)}
                  className="text-gray-300 hover:text-black dark:hover:text-white transition-colors"
                >
                  ×
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button
        onClick={addRow}
        className="mt-8 text-[10px] uppercase tracking-[0.2em] text-gray-400 hover:text-black dark:hover:text-white transition-colors flex items-center gap-2"
      >
        <span>+</span> Aggiungi Riga
      </button>
    </div>
  );
};

export default DeliverablesTable;
